import * as React from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";

export default function BarkprintsTable() {
  const [barkprints, setBarkprints] = React.useState([]);
  const [err, setErr] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  const columns = [
    {
      field: "user",
      headerName: "User",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "barkprint",
      headerName: "Barkprint",
      minWidth: 150,
      flex: 4,
    },
    {
      field: "timestamp",
      headerName: "Timestamp",
      minWidth: 150,
      flex: 2,
    },
    {
      field: "ipaddr",
      headerName: "ipaddr",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "useragent",
      headerName: "useragent",
      minWidth: 250,
      flex: 4,
    },
  ];

  React.useEffect(() => {
    axios
      .get(`/bark_prints`)
      .then((res) => {
        setBarkprints(res.data.barkprints);
        setIsLoading(false);
      })
      .catch((err) => {
        setErr(err.message);
      });
  }, []);

  return (
    <React.Fragment>
      {err ? (
        <p>{err}</p>
      ) : (
        <div
          id="m"
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "flex-end",
          }}
        >
          <Box sx={{ height: 660, width: "100%" }}>
            <DataGrid
              loading={isLoading}
              getRowHeight={() => "auto"}
              getRowId={(row) => row.internalId}
              rows={barkprints.map((barkprint, index) => {
                barkprint.internalId = index;
                return barkprint;
              })}
              columns={columns}
              
              pageSize={10}
              rowsPerPageOptions={[10]}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              initialState={{
                sorting: {
                  sortModel: [{ field: "id", sort: "desc" }],
                },
              }}
            />
          </Box>
        </div>
      )}
    </React.Fragment>
  );
}
